import React, {useState} from "react";
import {Columns, Modal, Section, Form, Table, Heading, Button} from "react-bulma-components";
import {useDispatch} from "react-redux";
import StageChangeRow from "./StageChangeRow";
import {NotificationManager} from "react-notifications";
import axios from "axios";
import {createSetDataFreshAction, createSetWorkDataAction} from "../../actions/dataActions";


export default function StateChangeModal({selectedWork, multi=false, setMulti, getCurrentState, setSelected, dataFresh, filteredWork, setFilteredWork, currentFilter, view, open, setOpen, endpoint, onWorkSave, onStageChange, workTypeObjects, workTypes, nominalCodes, codeObjects, trackingOptions, trackingOptionObjects}){
    let currentState;
    if(multi){
        currentState = getCurrentState(filteredWork.results[0]);
    }
    else{
        currentState = getCurrentState(selectedWork);
    }

    const onAmountPaidSave = (work, customerAmountPaid) => {
      // get job
      const url = endpoint + "jobs/" + work.job;
      const conf = {
        method: "get",
        url
      };

      return axios(conf).then(resp => {
          let jobData = resp.data;
          if(work.chargeable){
              jobData.customer2_paid_amount= customerAmountPaid
          }
          else if(!work.chargeable){
              jobData.customer1_paid_amount= customerAmountPaid
          }
          const putConf = {
              url: url,
              method: "put",
              data: jobData
          }
          axios(putConf)
      })
    }

    const getColor = () => {
        if(view === "po"){
            if(selectedWork && filteredWork){
                if(selectedWork.no_free_of_charge_count === filteredWork.results.length){
                    return "table-highlight-green";
                }
            }
        }
        else if(view === "invoice") {
            if (selectedWork && filteredWork) {
                if (selectedWork.work_count === filteredWork.results.length) {
                    return "table-highlight-green";
                }
            }
        }
        return "table-highlight-red";
    }
    const getTotalCustomerCharge = () => {
        let total = 0;
        filteredWork.results.forEach(item => {
            total = total + parseFloat(item.customer_labour_cost);
            item.parts.forEach(part => {
                total = total + parseFloat(part.customer_cost)
            })
        })
        return (Math.round((total + Number.EPSILON) * 100) / 100)
    }
    const getTotalChargeToUs = () => {
        let total = 0;
        filteredWork.results.forEach(item => {
            total = total + parseFloat(item.labour_cost);
            item.parts.forEach(part => {
                total = total + parseFloat(part.cost)
            })
        })
        return (Math.round((total + Number.EPSILON) * 100) / 100)
    }

    const getCustomer = () => {
        if(selectedWork.chargeable){
            //Customer 2
            return selectedWork.customer2
        }
        else if(!selectedWork.chargeable){
            //Customer 1
            return selectedWork.customer
        }
    }

    const onPartSave = (partIndex, work) => {
      const conf = {
          method: "put",
          url: endpoint+"parts/update/"+work.parts[partIndex].id,
          data: work.parts[partIndex]
      }
      return axios(conf).catch(err => {
          NotificationManager.error("There was an error");
      })
    };

    return (
        <Modal
            closeOnBlur
            show={open}
            onClose={() => {
                setFilteredWork({results: []});
                setSelected({})
                setMulti(false);
                setOpen(false);
            }}
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{ backgroundColor: "white" }}>
                    <Heading>All related work</Heading>
                    {!multi &&
                        <Columns>
                            <Columns.Column>
                                <Form.Field>
                                    <Form.Control>
                                        <Form.Label>Registration</Form.Label>
                                        <Form.Input
                                            type={"text"}
                                            value={selectedWork ? selectedWork.vehicle_registration : ""}
                                            disabled={true}
                                        />
                                    </Form.Control>
                                </Form.Field>
                            </Columns.Column>
                            <Columns.Column>
                                <Form.Field>
                                    <Form.Control>
                                        <Form.Label>Customer</Form.Label>
                                        <Form.Input
                                            type={"text"}
                                            value={selectedWork ? getCustomer() : ""}
                                            disabled={true}
                                        />
                                    </Form.Control>
                                </Form.Field>
                            </Columns.Column>
                            <Columns.Column>
                                <Form.Field>
                                    <Form.Control>
                                        <Form.Label>Workshop</Form.Label>
                                        <Form.Input
                                            type={"text"}
                                            value={selectedWork ? selectedWork.workshop : ""}
                                            disabled={true}
                                        />
                                    </Form.Control>
                                </Form.Field>
                            </Columns.Column>
                            <Columns.Column>
                                <Form.Field>
                                    <Form.Control>
                                        <Form.Label>{selectedWork ? (selectedWork.quote ? "Quote ID" : "Job ID") : ""}</Form.Label>
                                        <Form.Input
                                            type={"number"}
                                            value={selectedWork ? (selectedWork.quote ? selectedWork.quote : selectedWork.job) : ""}
                                            disabled={true}
                                        />
                                    </Form.Control>
                                </Form.Field>
                            </Columns.Column>
                            <Columns.Column>
                                <Form.Field>
                                    <Form.Control>
                                        <Form.Label>Total Work Items</Form.Label>
                                        <Form.Input
                                            type={"number"}
                                            disabled={true}
                                            className={getColor()}
                                            value={ view === "invoice" ? selectedWork ? selectedWork.work_count : "" : selectedWork ? selectedWork.no_free_of_charge_count : ""}
                                        />
                                    </Form.Control>
                                </Form.Field>
                            </Columns.Column>
                            <Columns.Column>
                                <Form.Field>
                                    <Form.Control>
                                        <Form.Label>Total Customer Charge (Inc Parts)</Form.Label>
                                        <Form.Input
                                            type={"number"}
                                            value={getTotalCustomerCharge()}
                                            disabled={true}
                                        />
                                    </Form.Control>
                                </Form.Field>
                            </Columns.Column>
                            <Columns.Column>
                                <Form.Field>
                                    <Form.Control>
                                        <Form.Label>Total Cost To Us (Inc Parts)</Form.Label>
                                        <Form.Input
                                            type={"number"}
                                            value={getTotalChargeToUs()}
                                            disabled={true}
                                        />
                                    </Form.Control>
                                </Form.Field>
                            </Columns.Column>
                        </Columns>
                    }
                    <Columns>
                        <Columns.Column>
                            <Table
                                size={"fullwidth"}
                            >
                                <thead>
                                    <tr>
                                        <th>Job ID</th>
                                        <th>Description</th>
                                        <th>Comments</th>
                                        <th>Labour Cost (£)</th>
                                        <th>Customer Labour Charge</th>
                                        <th>{view === 'po' ? 'Workshop Invoice Number' : 'Customer Invoice Number'}</th>
                                        <th>Nominal Code</th>
                                        <th>Tracking Category</th>
                                        {view === "invoice" && <th>Customer Paid</th>}
                                        {view === 'po' && <th>Work Type</th>}
                                        {view === 'po' && <th>Due Date</th>}
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {((filteredWork && filteredWork.results) ?? []).map((work, index) => (
                                        <StageChangeRow
                                            onWorkSave={onWorkSave}
                                            work={work}
                                            view={view}
                                            key={work.id}
                                            index={index}
                                            workTypeObjects={workTypeObjects}
                                            workTypes={workTypes}
                                            nominalCodes={nominalCodes}
                                            codeObjects={codeObjects}
                                            onPartSave={onPartSave}
                                            trackingOptionObjects={trackingOptionObjects}
                                            trackingOptions={trackingOptions}
                                            onAmountPaidSave={onAmountPaidSave}
                                        />
                                    ))}
                                </tbody>
                            </Table>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                fullwidth
                                color={"success"}
                                onClick={onStageChange}
                            >
                                {currentState === "ready_to_approve" ? "Approve" : view === "po" ? "Approve Payment" : "Ready to Invoice"}
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                fullwidth
                                color={"info"}
                                onClick={() => {
                                    setFilteredWork({results: []});
                                    setMulti(false);
                                    setSelected({});
                                    setOpen(false);
                                }}
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )


}